import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackFeature } from '@utils/trackFeature'

function screenIdFromPathname(pathname: string): string | null {
  if (!pathname.startsWith('/app') && !pathname.startsWith('/admin')) {
    return null
  }
  const normalized = pathname.replace(/\/+$/, '') || '/'
  return normalized.slice(1)
}

/**
 * Emits `screen_view` when `/app` or `/admin` pathname changes (not query-only).
 */
export function useFeatureUseRouteTracking(): void {
  const { pathname } = useLocation()
  const lastScreenRef = useRef<string | null>(null)

  useEffect(() => {
    const screen = screenIdFromPathname(pathname)
    if (!screen || screen === lastScreenRef.current) {
      return
    }
    lastScreenRef.current = screen
    trackFeature('screen_view', { screen })
  }, [pathname])
}
